import Axios from 'axios';
import { authHeader } from '../helpers';

export const FETCH_SMARTCHATAI_REPORT_DATA = 'FETCH_SMARTCHATAI_REPORT_DATA';
export const FETCH_SMARTCHATAI_REPORT_DATA_SUCCESS =
  'FETCH_SMARTCHATAI_REPORT_DATA_SUCCESS';
export const FETCH_SMARTCHATAI_REPORT_DATA_FAILURE =
  'FETCH_SMARTCHATAI_REPORT_DATA_FAILURE';

export const FETCH_SMARTCHATAI_REPORT_CHAT_TOPICS = 'FETCH_SMARTCHATAI_REPORT_CHAT_TOPICS';
export const FETCH_SMARTCHATAI_REPORT_CHAT_TOPICS_SUCCESS =
  'FETCH_SMARTCHATAI_REPORT_CHAT_TOPICS_SUCCESS';
export const FETCH_SMARTCHATAI_REPORT_CHAT_TOPICS_FAILURE =
  'FETCH_SMARTCHATAI_REPORT_CHAT_TOPICS_FAILURE';

//action for smart chat AI
export const fetchSmartChatAIReportData =
  (pageNo, pageLimit = 50, formData) =>
  async (dispatch) => {
    try {
      dispatch({ type: FETCH_SMARTCHATAI_REPORT_DATA });
      const smartChatAIReport = await Axios.get(
        `${process.env.REACT_APP_API_URL}/smart-ai/conversation/search?page=${pageNo}&limit=${pageLimit}`,
        { params: formData, headers: authHeader() },
      );
      dispatch({
        type: FETCH_SMARTCHATAI_REPORT_DATA_SUCCESS,
        payload: smartChatAIReport.data,
      });
    } catch (err) {
      dispatch({ type: FETCH_SMARTCHATAI_REPORT_DATA_FAILURE, error: err });
    }
  };

//fetch chat topics
export const fetchSmartChatAIChatTopics =
  () =>
  async (dispatch) => {
    try {
      dispatch({ type: FETCH_SMARTCHATAI_REPORT_CHAT_TOPICS });
      const smartChatAIChatTopics = await Axios.get(
        `${process.env.REACT_APP_API_URL}/smart-ai/chat-topics`,
        { headers: authHeader() },
      );
      dispatch({
        type: FETCH_SMARTCHATAI_REPORT_CHAT_TOPICS_SUCCESS,
        payload: smartChatAIChatTopics.data,
      });
    } catch (err) {
      dispatch({ type: FETCH_SMARTCHATAI_REPORT_CHAT_TOPICS_FAILURE, error: err });
    }
  };
